import {call, put} from 'redux-saga/effects';
import {receiveCarouselData} from "../actions/carouseActions";
import {fetchCarouselData} from "../api/fetchCarouselData";

export default function* getCarouselData(action) {
  try {
    const carouselData = yield call(fetchCarouselData);
    yield put(receiveCarouselData(carouselData));
  } catch (e) {
    console.log(e)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/carouselSaga.js